import * as authService from "../services/auth.service";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const setMenu = createAsyncThunk("setMenu", async (state: any) => {
  return state;
});
export const menuState = createAsyncThunk("menuState", async (state: any) => {
  return state;
});
